export const getLocaleFromUrl = () => {
    const url = window.location.pathname;
    const splited = url.split('/');
    return splited[1] || 'pt-br';
};

export const toJSON = response => response.json();

export const formatRequestDate = date => date.toISOString().split('T')[0];

export const getDaysAgoRequestInterval = (numDays, isTodayInclusive = false) => {
    const endDate = new Date();
    if (!isTodayInclusive) {
        endDate.setDate(endDate.getDate() - 1);
    }
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - numDays);
    return [formatRequestDate(startDate), formatRequestDate(endDate)];
};

const CARD_OBJECT_TO_IDS_FIELDS = ['account', 'assignee', 'assignees', 'client', 'campaign'];

export const migrateCardObjectToApiFormat = (object) => {
    const newObject = { ...object };
    CARD_OBJECT_TO_IDS_FIELDS.forEach((field) => {
        const objectContainsField = object[field] && typeof (object[field]) === 'object';
        if (objectContainsField) {
            if (field === 'assignees') {
                newObject[field] = object.assignees.map(
                    assignee => assignee.assignee,
                );
            } else newObject[field] = object[field].id;
        }
    });

    if (newObject.custom_data && typeof (newObject.custom_data) === 'object') {
        newObject.custom_data = JSON.stringify(newObject.custom_data);
    }

    return newObject;
};
